var path = 'src/app/forms/fields/confirm-email-field.html';
var html = "<input frm-model frm-required equal-to-validator=email ng-required=required() ng-model=model type=text class=form-control /> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/confirm-email-field.html
 ** module id = 257
 ** module chunks = 0
 **/